module.exports = __webpack_public_path__ + "static/media/bree.af77be48.png";